import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomeView.vue";
import Login from "../views/LoginView.vue";
import Dashboard from "../views/DashboardView.vue";
import Guests from "../views/GuestsView.vue";
import Body from "../views/BodyView.vue";


const routes = [
  { path: "/", component: Home },
   { path: "/body", component: Body },
  { path: "/login", component: Login },
  { path: "/dashboard", component: Dashboard, meta: { requiresAuth: true } },
  { path: "/dashboard/guests", component: Guests, meta: { requiresAuth: true } }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // Check all matched routes for requiresAuth
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    next({ path: "/login", query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
